import { e2eeModel } from 'APP/model/model';

export const secretChatRequestAccess = async (groupId: string): Promise<boolean> => {
  try {
    const response = await e2eeModel.createSecretChatRequestAccess(groupId);

    return response.result;
  } catch (e) {
    return false;
  }
};
